import { TableCell, TableHead, TableSortLabel } from '@material-ui/core'
import moment from 'moment'
import { useMemo } from 'react'
import { yyyyMMDDHHmmFormat } from 'services/dateFormat-service'
import { CHANGE_FILTER_STATE } from '../services/users-actions'
import { UserFilterSort, UsersFilterState } from './types'

import Paper from '@material-ui/core/Paper'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableContainer from '@material-ui/core/TableContainer'
import TableFooter from '@material-ui/core/TableFooter'
import TablePagination from '@material-ui/core/TablePagination'
import TableRow from '@material-ui/core/TableRow'
import map from 'lodash/map'
import { useDispatch } from 'react-redux'
import { useAppSelector } from 'utils/reduxHelpers'
import { useStyles } from './style'
import UsersFilter from './UsersFilter'

const UsersTableComponent = () => {
  const dispatch = useDispatch()
  const styles = useStyles()

  const users = useAppSelector((state) => state.usersReducer.users)
  const filterState = useAppSelector((state) => state.usersReducer.userFilters)
  const count = useAppSelector((state) => state.usersReducer.count)

  const applyFilter = (filterState: UsersFilterState) =>
    dispatch(CHANGE_FILTER_STATE(filterState))

  const toggleSort = (newSort: UserFilterSort) => {
    const { sort, sortDirection } = filterState
    applyFilter({
      ...filterState,
      sort: newSort,
      sortDirection:
        newSort === sort
          ? sortDirection === 'asc'
            ? 'desc'
            : 'asc'
          : sortDirection,
    })
  }

  return (
    <>
      <div className={styles.tableContainer}>
        <UsersFilter />
        <TableContainer component={Paper}>
          <Table id="users-table">
            <TableHead>
              <TableRow>
                <TableCell>ID</TableCell>
                <TableCell
                  sortDirection={
                    filterState.sort === 'firstName'
                      ? filterState.sortDirection
                      : false
                  }
                >
                  <TableSortLabel
                    active={filterState.sort === 'firstName'}
                    direction={filterState.sortDirection}
                    onClick={() => toggleSort('firstName')}
                  >
                    First Name
                  </TableSortLabel>
                </TableCell>
                <TableCell
                  sortDirection={
                    filterState.sort === 'lastName'
                      ? filterState.sortDirection
                      : false
                  }
                >
                  <TableSortLabel
                    active={filterState.sort === 'lastName'}
                    direction={filterState.sortDirection}
                    onClick={() => toggleSort('lastName')}
                  >
                    Last Name
                  </TableSortLabel>
                </TableCell>
                <TableCell
                  sortDirection={
                    filterState.sort === 'roleName'
                      ? filterState.sortDirection
                      : false
                  }
                >
                  <TableSortLabel
                    active={filterState.sort === 'roleName'}
                    direction={filterState.sortDirection}
                    onClick={() => toggleSort('roleName')}
                  >
                    Role
                  </TableSortLabel>
                </TableCell>
                <TableCell
                  sortDirection={
                    filterState.sort === 'organizationName'
                      ? filterState.sortDirection
                      : false
                  }
                >
                  <TableSortLabel
                    active={filterState.sort === 'organizationName'}
                    direction={filterState.sortDirection}
                    onClick={() => toggleSort('organizationName')}
                  >
                    Organization
                  </TableSortLabel>
                </TableCell>
                <TableCell>Organization Active</TableCell>
                <TableCell
                  sortDirection={
                    filterState.sort === 'email'
                      ? filterState.sortDirection
                      : false
                  }
                >
                  <TableSortLabel
                    active={filterState.sort === 'email'}
                    direction={filterState.sortDirection}
                    onClick={() => toggleSort('email')}
                  >
                    Email
                  </TableSortLabel>
                </TableCell>
                <TableCell>Active</TableCell>
                <TableCell
                  sortDirection={
                    filterState.sort === 'lastLoginDate'
                      ? filterState.sortDirection
                      : false
                  }
                >
                  <TableSortLabel
                    active={filterState.sort === 'lastLoginDate'}
                    direction={filterState.sortDirection}
                    onClick={() => toggleSort('lastLoginDate')}
                  >
                    Last Active
                  </TableSortLabel>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {useMemo(() => {
                return map(users || [], (user) => {
                  return (
                    <TableRow key={user.id}>
                      <TableCell>{user.id}</TableCell>
                      <TableCell>{user.firstName}</TableCell>
                      <TableCell>{user.lastName}</TableCell>
                      <TableCell>{user.roleName}</TableCell>
                      <TableCell>{user.organizationName}</TableCell>
                      <TableCell>
                        {user.organizationActive ? 'Yes' : 'No'}
                      </TableCell>
                      <TableCell>{user.email}</TableCell>
                      <TableCell>{user.active ? 'Yes' : 'No'}</TableCell>
                      <TableCell>
                        {user.lastLoginDate
                          ? moment(user.lastLoginDate).format(
                              yyyyMMDDHHmmFormat
                            )
                          : '—'}
                      </TableCell>
                    </TableRow>
                  )
                })
              }, [users])}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[10, 30, 50]}
                  colSpan={9}
                  count={count}
                  rowsPerPage={filterState.pageSize}
                  page={filterState.pageNum}
                  onPageChange={(event, newPage) => {
                    applyFilter({
                      ...filterState,
                      pageNum: newPage,
                    })
                  }}
                  onRowsPerPageChange={(event) => {
                    applyFilter({
                      ...filterState,
                      pageNum: 0,
                      pageSize: parseInt(event.target.value, 10),
                    })
                  }}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      </div>
    </>
  )
}

export default UsersTableComponent
